import { Col } from 'antd'
import styled from 'styled-components'

const StyledMenuTitleDescriptionContainer = styled(Col)`
  max-width: 700px;
`

export default StyledMenuTitleDescriptionContainer
